<template>
  <main class="u-container">
    <header>
      <h1 class="text-base font-bold">
        {{ message || defaultMessage }}
      </h1>
      <router-link
        :to="{ name: 'home' }"
        class="c-btn--secondary mt-6 mr-6"
      >
        Exit
      </router-link>
      <router-link
        v-if="!message"
        :to="{ name: 'edit' }"
        class="c-btn mt-3"
      >
        Edit Address
      </router-link>
    </header>
  </main>
</template>

<script>
export default {
  name: 'FatalError',
  data() {
    return {
      /*
       A backend business message (for example an already-canceled COA) is passed in through the
       store and shown in place of the generic text. For that case the "Edit Address" action is
       hidden because the order can no longer be edited.
      */
      message: this.$store.getters.apiMessage || '',
      defaultMessage: 'The Change-of-Address application has experienced an error and your request could not be processed.',
    };
  },
  created() {
    /* Consume the message once so it cannot leak onto a later, unrelated error screen. */
    if (this.message) {
      this.$store.commit('RESET_ERROR');
    }
  },
};
</script>
